// src/services/Meetupsdtlbannersec.js
import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchdestination = async (city) => {
  try {
    const response = await fetch(`${API_URL}/destinationsDetaillist`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ city }),
    });

    return await response.json();
  } catch (error) {
    console.log("API Error:", error);
    return null;
  }
};